import type {
  CustomerListSegment,
  CustomerStatsResponse,
} from "@/lib/admin-api/crm";
import type { LoyaltyTier } from "./types";

// ---------------------------------------------------------------------------
// Segment badge colors & labels
// ---------------------------------------------------------------------------

export const SEGMENT_STYLES: Record<CustomerListSegment, string> = {
  new: "bg-blue-50 text-blue-700 border-blue-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  vip: "bg-amber-50 text-amber-700 border-amber-200",
  at_risk: "bg-orange-50 text-orange-700 border-orange-200",
  churned: "bg-stone-100 text-stone-500 border-stone-200",
  wholesale: "bg-violet-50 text-violet-700 border-violet-200",
};

export const SEGMENT_LABELS: Record<CustomerListSegment, string> = {
  new: "Nouveau",
  active: "Régulier",
  vip: "VIP",
  at_risk: "À risque",
  churned: "Inactif",
  wholesale: "Grossiste",
};

export const LOYALTY_STYLES: Record<LoyaltyTier, string> = {
  bronze: "text-amber-700",
  silver: "text-stone-500",
  gold: "text-amber-500",
  platinum: "text-violet-600",
};

export const LOYALTY_LABELS: Record<LoyaltyTier, string> = {
  bronze: "Bronze",
  silver: "Argent",
  gold: "Or",
  platinum: "Platine",
};

// ---------------------------------------------------------------------------
// Pagination
// ---------------------------------------------------------------------------

export const PAGE_SIZE = 10;

// ---------------------------------------------------------------------------
// All segments (for filter)
// ---------------------------------------------------------------------------

export const ALL_SEGMENTS: Array<CustomerListSegment | "all"> = [
  "all", "vip", "active", "new", "at_risk", "wholesale", "churned",
];

export const REGION_OPTIONS = [
  "Toutes", "Dakar", "Kaolack", "Saint-Louis", "Fatick", "Thiès-Mbour", "Diourbel-Touba",
];

// Empty stats placeholder used while the stats query is loading, so KPI
// cards render a skeleton-like zero state instead of crashing.
export const EMPTY_STATS: CustomerStatsResponse = {
  total: 0,
  new_this_month: 0,
  avg_value_fcfa: 0,
  retention_rate: 0,
  segment_counts: {
    new: 0,
    active: 0,
    vip: 0,
    at_risk: 0,
    wholesale: 0,
    churned: 0,
  },
  region_counts: {},
};
